import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import GlobalStyles from './global-style';
import configureStore from './state';
import { fetchData } from './state/actions/createData';
import { domListeners } from './state/actions/createBrowserUtils';

import Header from './views/header';
import Footer from './views/footer';
import Content from './views/content';
import ContentPopulation from './views/contentPopulation';

const store = configureStore();

const element = (
  <Provider store={store}>
    <GlobalStyles />
    <div className="content-wrap">
      <section>
        <div className="inner-section">
          <Header />
          <Content />
          <ContentPopulation />
        </div>
      </section>
      <section>
        <Footer />
      </section>
      <div className="min-height-push" />
    </div>
  </Provider>
);

ReactDOM.render(element, document.getElementById('foot'));

/* Start up functions */
store.dispatch(domListeners());
store.dispatch(fetchData());
